/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy';
import { IRoof } from './DataServiceEntities.g';
import { createGetRoofItemReferencesByModelInput } from './DataActionExtension.g';

export default createObservableDataAction({
    action: <IAction<IRoof[]>>retailAction,
    input: (context: ICreateActionContext, modelId: any) => {
        return createGetRoofItemReferencesByModelInput({ Paging: { Top: 0 } }, modelId);
    }
});

/**
 * GetRoofTable Input Action
 */
/*export class GetRoofTableInput implements IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DEFAULT`;
    public getCacheObjectType = () => 'IGetRoofTable';
    public dataCacheType = (): CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetRoofTableData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
/*export const createInput = (args: ICreateActionContext): IActionInput => {
    return new GetRoofTableInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
/*export async function getRoofTableAction(input: GetRoofTableInput, ctx: IActionContext): Promise<IRoofTable[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetRoofTable2Data[]>('/get/example/id/1', 'get');
    return <IRoofTable[]>(<unknown>getRoofTableAsync({ callerContext: ctx }));
}

/**
 * Get roof table data action
 */
/*export const getRoofTableActionDataAction = createObservableDataAction({
    id: 'get-roof-table',
    action: <IAction<IRoofTable[]>>getRoofTableAction,
    input: createInput
});

export default getRoofTableActionDataAction;*/
